import { format } from 'date-fns';

/**
 * Returns a `YYYY-MM-DD` string for the given date in the device's LOCAL
 * calendar. Use this everywhere we key against `health_metrics.metric_date`
 * (which is written from Swift using local-calendar buckets) - the previous
 * `toISOString().split('T')[0]` shortcut is UTC and will return yesterday's
 * key any time the user is west of UTC after local midnight.
 */
export function getLocalDayKey(date: Date = new Date()): string {
  return format(date, 'yyyy-MM-dd');
}

/**
 * Returns a `Date` set to local midnight of "today minus `daysAgo` days".
 * Useful for ".gte(metric_date, ...)" range queries that must include the
 * full local day.
 */
export function getLocalDateDaysAgo(daysAgo: number): Date {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() - daysAgo);
  return d;
}

/**
 * Inclusive local calendar range: exactly `days` days ending on "today" (local midnight).
 * Use this for nutrition + health_metrics charts so L7D / L30D / L3M stay aligned.
 * (Avoid `toISOString().split('T')[0]` — it uses UTC and can shift the calendar day.)
 */
export function getInclusiveLocalDayRange(days: number): {
  startDate: Date;
  endDate: Date;
  startStr: string;
  endStr: string;
} {
  const endDate = new Date();
  endDate.setHours(0, 0, 0, 0);
  const startDate = new Date(endDate);
  startDate.setDate(startDate.getDate() - (days - 1));
  return {
    startDate,
    endDate,
    startStr: format(startDate, 'yyyy-MM-dd'),
    endStr: format(endDate, 'yyyy-MM-dd'),
  };
}
